import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SettingsProvider } from '@services/settings/settings';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomizedLabels } from '@models/models';

@Component({
	selector: 'quote-job-info',
	template: require('./quote-job-info.html'),
	styles: [require('./quote-job-info.scss')]
})
export class QuoteJobInfoComponent implements OnInit, OnDestroy {
	@Input('job') job;
	@Input() fromQuoteView: boolean;

	private shootsLabelName: string;
	private unsubscribe: Subject<void> = new Subject<void>();

	constructor(private settingsService: SettingsProvider) {}

	ngOnInit(): void {
		this.subscribeToCustomizeLabelsChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private subscribeToCustomizeLabelsChange(): void {
		this.settingsService.customizeLabelsObservable
			.pipe(takeUntil(this.unsubscribe))
			.subscribe(
				(customizeLabels: CustomizedLabels): string =>
					(this.shootsLabelName = customizeLabels.mainShootLabel)
			);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/quotes/common/quote-job-info/quote-job-info.ts